if (document.querySelectorAll(".card-square").length > 1) {
  const ui = {
    squareCards: document.querySelectorAll('[adaptive-height="parent"]'),
  }

  const data = {
    biggestHeight: 0,
    titleBiggestHeight: 0,
    windowWidth: window.innerWidth,
  }

  window.addEventListener("load", (event) => {
    if (data.windowWidth > 768) {
      setBiggestHeight(ui.squareCards)
    }
  })

  const setBiggestHeight = (parentName) => {
    data.biggestHeight = 0

    if (parentName) {
      parentName.forEach((parentItem, index) => {
        let childItems = document.querySelectorAll(`[parent-index="${index}"] [adaptive-height="child"]`);
        let columnItems = document.querySelectorAll(`[parent-index="${index}"] .is-column`);

        console.log('columnItems', columnItems)

        setColumnSizeClass(columnItems);

        childItems.forEach((item) => {
          const currentHeight = item.scrollHeight
          const currentTitleHeight = item.querySelector(".header").scrollHeight

          if (currentHeight > data.biggestHeight) data.biggestHeight = currentHeight

          if (currentTitleHeight > data.titleBiggestHeight) data.titleBiggestHeight = currentTitleHeight
        })

        setAdaptiveHeight(childItems, data.biggestHeight)
        setAdaptiveTitleHeight(childItems, data.titleBiggestHeight)
      })
    }
  }

  const setAdaptiveHeight = (parentName, biggestHeight) => {
    parentName.forEach((item) => {
      item.style.minHeight = `${biggestHeight}px`
    })
  }

  const setAdaptiveTitleHeight = (parentName, biggestHeight) => {
    parentName.forEach((item) => {
      item.querySelector(".header").style.minHeight = `${biggestHeight}px`
    })
  }

  const setColumnSizeClass = (parentName) => {
    const columnSize = 12/parentName.length;

    parentName.forEach((item) => {
      item.classList.add(`col-lg-${columnSize}`);
    })
  }
}
